import React from 'react';
import { MapPin } from 'lucide-react';

const SEOSection = () => {
  const locations = [
    { name: 'Strasbourg', department: 'Bas-Rhin (67)' },
    { name: 'Mulhouse', department: 'Haut-Rhin (68)' },
    { name: 'Colmar', department: 'Haut-Rhin (68)' },
    { name: 'Haguenau', department: 'Bas-Rhin (67)' },
    { name: 'Sélestat', department: 'Bas-Rhin (67)' },
    { name: 'Obernai', department: 'Bas-Rhin (67)' },
    { name: 'Saverne', department: 'Bas-Rhin (67)' },
    { name: 'Thann', department: 'Haut-Rhin (68)' },
    { name: 'Nancy', department: 'Meurthe-et-Moselle (54)' },
    { name: 'Metz', department: 'Moselle (57)' }
  ];

  const services = [
    'Film de mariage complet',
    'Teaser de mariage',
    'Vidéo mariage cinématique',
    'Film mariage avec drone',
    'Reportage vidéo mariage',
    'Vidéo mariage style vintage',
    'Mariage à destination',
    'Cérémonies laïques'
  ];

  return (
    <section className="py-20 px-4 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        {/* Zones d'intervention */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <div className="w-16 h-16 bg-light-pink rounded-full flex items-center justify-center mx-auto mb-6">
              <MapPin className="w-8 h-8 text-black" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Vidéaste Mariage dans Toute l'Alsace
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Nous intervenons dans tout le <strong className="text-white">Grand Est</strong> pour vos films de mariage
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
            {locations.map((location, index) => (
              <div 
                key={index}
                className="bg-black p-4 rounded-lg border border-zinc-800 text-center hover:border-light-pink transition-colors"
              >
                <h3 className="text-lg font-semibold text-white mb-1">{location.name}</h3>
                <p className="text-sm text-gray-400">{location.department}</p>
              </div>
            ))}
          </div>

          <div className="bg-black p-8 rounded-lg border border-zinc-800">
            <h3 className="text-2xl font-bold mb-4 text-center">Vidéaste Mariage Professionnel en Alsace</h3>
            <p className="text-lg text-gray-300 leading-relaxed mb-4">
              En tant que <strong className="text-white">vidéaste mariage à Strasbourg</strong> et dans toute la région <strong className="text-white">Grand Est</strong>, 
              je vous propose des <strong className="text-white">films de mariage</strong> de qualité professionnelle. Spécialisé dans la <strong className="text-white">vidéo mariage cinématique</strong>, 
              je réalise également des <strong className="text-white">films mariage avec drone</strong> pour des prises de vue aériennes spectaculaires.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed mb-4">
              Que vous vous mariiez dans le <strong className="text-white">Bas-Rhin (67)</strong> à Strasbourg centre-ville, Obernai ou Sélestat, 
              ou dans le <strong className="text-white">Haut-Rhin (68)</strong> à Mulhouse, Colmar ou dans les vignobles alsaciens, je me déplace 
              pour capturer votre <strong className="text-white">reportage vidéo mariage</strong>.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed">
              Mon travail de <strong className="text-white">vidéaste mariage en Alsace</strong> comprend la réalisation de <strong className="text-white">teasers de mariage</strong>, 
              de <strong className="text-white">films complets</strong>, et même des vidéos au <strong className="text-white">style vintage</strong>. 
              Je propose également mes services pour les <strong className="text-white">mariages à destination</strong> dans toute la région Grand Est.
            </p>
          </div>
        </div>

        {/* Services */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">
            Nos Services de Vidéaste Mariage
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-black p-6 rounded-lg border border-zinc-800 text-center hover:bg-zinc-900 transition-colors"
              >
                <p className="text-white font-medium">{service}</p>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ Section pour SEO */}
        <div className="mt-16 bg-black p-8 rounded-lg border border-zinc-800">
          <h2 className="text-3xl font-bold mb-8 text-center">Questions Fréquentes</h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-light-pink mb-2">
                Pourquoi choisir un vidéaste mariage professionnel en Alsace ?
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Un vidéaste mariage professionnel dispose du matériel et de l'expérience nécessaires pour capturer 
                la magie de votre jour J. Avec des caméras 4K, un drone et un équipement audio professionnel, 
                je garantis un film de mariage de qualité cinématographique qui vous permettra de revivre ces 
                moments précieux pendant des années.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-light-pink mb-2">
                Quelle est la différence entre un teaser et un film complet de mariage ?
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Le teaser de mariage est une vidéo courte (3-5 minutes) dynamique et émotionnelle, parfaite pour 
                partager rapidement sur les réseaux sociaux. Le film complet (20-40 minutes) retrace l'intégralité 
                de votre journée avec tous les moments importants : préparatifs, cérémonie, cocktail, soirée.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-light-pink mb-2">
                Proposez-vous des vidéos de mariage avec drone en Alsace ?
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Oui ! Je suis pilote de drone certifié et je propose l'option drone (+250€) pour des prises de vue 
                aériennes spectaculaires de votre lieu de réception en Alsace. Le drone Mavic Pro 4 permet de 
                sublimer vos vidéos avec des plans cinématiques uniques.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-light-pink mb-2">
                Vous déplacez-vous dans tout le Grand Est ?
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Absolument ! Basé en Alsace, je me déplace dans tout le Grand Est : Bas-Rhin, Haut-Rhin, Moselle, 
                Meurthe-et-Moselle, Vosges, Meuse. Que votre mariage soit à Strasbourg, Mulhouse, Colmar, Nancy, 
                Metz ou ailleurs dans la région, je suis disponible.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SEOSection;